import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

import { useStyles } from './../../styles'

interface IProps {
  title: string | ReactNode
  node: ReactNode
  direction?: 'column' | 'row'
  sx?: object
}

export const CollapsedItem = ({ title, node, direction = 'row', sx = {} }: IProps) => {
  const classes = useStyles()

  return (
    <Box sx={{ display: 'flex', gap: '12px', flexDirection: direction, ...sx }}>
      <Typography className={classes.itemText}>{title}:</Typography>
      {node}
    </Box>
  )
}
